import { useState } from 'react';
import { useAuth } from '../hooks/useAuth';
import { useParams } from 'react-router';

import useFormValidation from '../hooks/useFormValidation';
import AuthLayout from '../components/AuthLayout';
import Button from '../components/inputs/Button';
import TextInput from '../components/inputs/TextInput';
import ThemeLink from '../components/ThemeLink';
import LoadingSpinner from '../components/LoadingSpinner';
import { validatePasswordField } from '../helpers/validators';
import ErrorText from '../components/ErrorText';

export default function VerifyForgotPassword() {
  const { verifyresetpassword } = useAuth();

  const [success, setSuccess] = useState(false);
  const [error, setError] = useState();
  const [resettingPassword, setResettingPassword] = useState(false);
  const [password, setPassword] = useState('');

  const [email, setEmail] = useState();
  const { resetToken } = useParams();
  const [invalidFields, validatedFields, validateField, validateForm] =
    useFormValidation([{ name: 'password', validator: validatePasswordField }]);

  function handleChangePassword(e) {
    const { value } = e.target;
    setPassword(value);
  }

  function handleSubmit(e) {
    e.preventDefault();

    if (validateForm({ password }, setError)) {
      setResettingPassword(true);
      verifyresetpassword(resetToken, password)
        .then((email) => {
          setSuccess(true);
          setEmail(email);
        })
        .catch((err) => {
          console.error(err.message);
          setError(err.message);
        })
        .finally(() => {
          setResettingPassword(false);
        });
    }
  }

  return (
    <AuthLayout>
      {!resetToken && (
        <div>
          <p>
            Uh oh, this reset link is invalid or expired. Please try resetting
            your password again{' '}
            <ThemeLink to="/resetpassword">Reset Password</ThemeLink>.
          </p>
        </div>
      )}
      {resetToken && !resettingPassword && !success && (
        <form className="flex flex-col text-center" onSubmit={handleSubmit}>
          <h4>Change Password</h4>
          <p className="mb-8">Please enter your new password.</p>
          <TextInput
            type="password"
            name="password"
            placeholder="Enter a new password"
            value={password}
            onChange={handleChangePassword}
            onBlur={() => {
              validateField('password', password, (err) => {
                setError(err);
              });
            }}
            validated={validatedFields.includes('password') || undefined}
            error={invalidFields.includes('password') || undefined}
          />
          {error && <ErrorText message={error} />}
          <Button
            className="mt-14"
            type="submit"
            primary
            disabled={invalidFields.length > 0}
          >
            Change Password
          </Button>
        </form>
      )}
      {!error && resettingPassword && (
        <LoadingSpinner message="Resetting password..." />
      )}
      {!error && success && (
        <div className="text-center">
          <p className="mb-3 font-light text-3xl">
            Your password has been successfully changed.
          </p>
          <p>
            Please{' '}
            <ThemeLink to="/signin" state={{ email }}>
              Sign In.
            </ThemeLink>
          </p>
        </div>
      )}
    </AuthLayout>
  );
}
